import react from '../assets/skillset/physics.png'
import git from '../assets/skillset/git.png'
import html from '../assets/skillset/html.png'
import css from '../assets/skillset/css-3.png'
import js from '../assets/skillset/js.png'
import npm from '../assets/skillset/npm.png'
import styledComponents from '../assets/skillset/styled-components.png'
import webpack from '../assets/skillset/webpack-icon (1).png'
import github from '../assets/github.png'
import TypesCript from '../assets/skillset/Typescript_logo_2020.svg.png';


export const iconsSkillset = [
    {
        img: html,
        title: 'HTML'
    },
    {
        img: css,
        title: 'CSS'
    },
    {
        img: js,
        title: 'Javascript'
    },
    {
        img: react,
        title: 'React'
    },
    {
        img: npm,
        title: 'NPM'
    },
    {
        img: git,
        title: 'GIT'
    },
    {
        img: github,
        title: 'Github'
    },
    {
        img: styledComponents,
        title: 'Styled-Components'
    },
    {
        img: webpack,
        title: 'Webpack'
    },
    {
        img: TypesCript,
        title: 'TypesCript'
    },
]